<template>
  <div class="modal fade show d-block modal-overlay">
    <div class="modal-dialog modal-lg modal-full-mobile">
      <div class="modal-content kho-modal-wrapper">

        <div class="modal-header bg-primary text-white align-items-start">
          <div class="w-100">
            <div class="d-flex justify-content-between align-items-start">
              <div class="mr-2">
                <div class="h5 font-weight-bold mb-1 d-flex align-items-center">
                  <i class="fa fa-archive mr-2"></i>
                  Nhiệm vụ Soạn Hàng
                </div>
                <div class="small text-white-50">
                  Mã đơn:
                  <span class="font-weight-bold text-white">
                    {{ task?.donHang?.tenDonHang || 'N/A' }}
                  </span>
                  <span v-if="task?.donHang?.id" class="text-white-50">
                    (#{{ task.donHang.id }})
                  </span>
                </div>
              </div>

              <button
                type="button"
                class="close text-white ml-auto p-2"
                @click="$emit('close')"
                :disabled="isSubmitting"
              >
                <span>&times;</span>
              </button>
            </div>

            <div v-if="task" class="mt-2 d-flex flex-wrap align-items-center">
              <span class="badge badge-light text-dark mr-2 mb-1">
                <i class="fa fa-map-marker text-danger mr-1"></i>
                {{ task.donHang?.diaChiGiaoHang || 'N/A' }}
              </span>

              <span class="badge mr-2 mb-1"
                :class="{
                  'badge-warning': task.trangThai === 'CHO_SOAN_HANG',
                  'badge-success': task.trangThai === 'DA_SOAN_HANG',
                  'badge-primary': task.trangThai === 'HOAN_THANH',
                  'badge-danger': task.trangThai === 'BAO_THIEU_HANG'
                }"
              >
                {{ task.trangThai || '---' }}
              </span>

              <span class="badge badge-info mb-1">
                {{ task.loaiDiemDung || '---' }}
              </span>
            </div>
          </div>
        </div>

        <div class="modal-body">
          <div v-if="!task" class="alert alert-danger">
            Lỗi: Không có dữ liệu nhiệm vụ.
          </div>

          <div v-else>

            <!-- PHẦN 1: THÔNG TIN ĐƠN HÀNG -->
            <div class="section-block">
              <div class="section-header">
                <span class="section-index bg-primary text-white">1</span>
                <span class="section-title">Thông tin Đơn hàng</span>
              </div>

              <div class="info-row">
                <div class="info-label">Đơn hàng</div>
                <div class="info-value font-weight-bold">
                  {{ task.donHang?.tenDonHang || 'N/A' }}
                  <span v-if="task.donHang?.id" class="text-muted small">(#{{ task.donHang.id }})</span>
                </div>
              </div>

              <div class="info-row">
                <div class="info-label">Nơi giao</div>
                <div class="info-value">
                  {{ task.donHang?.diaChiGiaoHang || 'N/A' }}
                </div>
              </div>

              <div class="info-row">
                <div class="info-label">Sales</div>
                <div class="info-value">
                  {{ task.donHang?.tenNguoiTao || '---' }}
                </div>
              </div>

              <div class="info-row">
                <div class="info-label">Thời điểm tạo</div>
                <div class="info-value">
                  {{ task.donHang?.ngayTao || '---' }}
                </div>
              </div>
            </div>

            <!-- PHẦN 2: VẬT TƯ TỪ SALES -->
            <div class="section-block">
              <div class="section-header">
                <span class="section-index bg-primary text-white">2</span>
                <span class="section-title">Thông tin Vật tư (Sales gửi)</span>
              </div>

              <div class="info-row align-items-start">
                <div class="info-label">File/Ảnh chung</div>
                <div class="info-value">
                  <div v-if="task.donHang?.fileUrl">
                    <div class="row no-gutters align-items-center">
                      <div class="col-auto pr-2">
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-info"
                          @click="openSalesImage(task.donHang.fileUrl)"
                        >
                          <i class="fa fa-image mr-1"></i> Xem ảnh
                        </button>
                      </div>
                      <div class="col">
                        <a
                          :href="task.donHang.fileUrl"
                          target="_blank"
                          rel="noopener"
                          class="small d-block text-truncate"
                        >
                          {{ task.donHang.fileUrl }}
                        </a>
                      </div>
                    </div>

                    <div class="sales-image-thumb mt-2" @click="openSalesImage(task.donHang.fileUrl)">
                      <img
                        :src="task.donHang.fileUrl"
                        class="img-fluid rounded border"
                        style="max-height:140px;object-fit:cover"
                        @error="onImgErr($event)"
                      />
                      <div class="thumb-overlay">
                        <i class="fa fa-search-plus"></i>
                      </div>
                    </div>
                  </div>

                  <div v-else class="text-muted">
                    Không có file chung.
                  </div>
                </div>
              </div>

              <div class="info-row">
                <div class="info-label">Ghi chú Sales</div>
                <div class="info-value">
                  <pre class="pre-block">
{{ task.donHang?.ghiChuSales || '-' }}
                  </pre>
                </div>
              </div>
            </div>

            <!-- PHẦN 3: NHIỆM VỤ CỦA TÔI -->
            <div class="section-block">
              <div class="section-header">
                <span class="section-index bg-danger text-white">3</span>
                <span class="section-title text-danger">
                  Nhiệm vụ của Tôi
                </span>
              </div>

              <div class="info-row">
                <div class="info-label">Điểm soạn</div>
                <div class="info-value font-weight-bold">
                  {{ task.tenDiemDung || '---' }}
                </div>
              </div>

              <div class="info-row">
                <div class="info-label">Loại điểm dừng</div>
                <div class="info-value">
                  <span class="badge badge-secondary">
                    {{ task.loaiDiemDung || '---' }}
                  </span>
                </div>
              </div>

              <div class="info-row">
                <div class="info-label">Trạng thái</div>
                <div class="info-value">
                  <span
                    class="badge"
                    :class="{
                      'badge-warning': task.trangThai === 'CHO_SOAN_HANG',
                      'badge-success': task.trangThai === 'DA_SOAN_HANG',
                      'badge-primary': task.trangThai === 'HOAN_THANH',
                      'badge-danger': task.trangThai === 'BAO_THIEU_HANG'
                    }"
                  >
                    {{ task.trangThai || '---' }}
                  </span>
                </div>
              </div>

              <div class="info-row">
                <div class="info-label">Phụ trách điểm này</div>
                <div class="info-value">
                  {{ task.tenNguoiPhuTrachKho || '---' }}
                </div>
              </div>

              <div class="info-row">
                <div class="info-label">Hoàn thành lúc</div>
                <div class="info-value">
                  {{ task.thoiDiemHoanThanh || 'Chưa xong' }}
                </div>
              </div>

              <div class="info-row align-items-start">
                <div class="info-label">Ghi chú chi tiết</div>
                <div class="info-value">
                  <pre class="pre-block min-100">
{{ task.chiTietVatTu || 'Không có ghi chú chi tiết' }}
                  </pre>
                </div>
              </div>

              <div class="info-row align-items-start">
                <div class="info-label">Địa chỉ điểm dừng</div>
                <div class="info-value">
                  <pre class="pre-block">{{ task.diaChi || '-' }}</pre>
                </div>
              </div>
            </div>

            <!-- PHẦN 4: HÀNH ĐỘNG THAO TÁC -->
            <div
              v-if="task.trangThai === 'CHO_SOAN_HANG'"
              class="section-block action-block"
            >
              <div class="section-header">
                <span class="section-index bg-success text-white">4</span>
                <span class="section-title text-success">
                  Báo cáo Soạn Hàng
                </span>
              </div>

              <div class="small text-muted mb-2">
                Sau khi soạn đủ hàng cho điểm này, chụp hình lại và xác nhận.
              </div>

              <!-- ẢNH XÁC MINH -->
              <div class="form-group">
                <label class="font-weight-bold d-block">
                  Ảnh xác minh hàng đã soạn
                  <span class="text-danger">*</span>
                </label>

                <div class="d-flex flex-wrap align-items-start">
                  <CameraCapture
                    v-model="soanXongImageUrl"
                    folder-name="kho_soan_hang"
                    file-name-prefix="soan-hang"
                    modal-title="Chụp ảnh Hàng Đã Soạn"
                    button-text="Chụp ảnh"
                    button-class="btn btn-outline-secondary btn-block btn-capture"
                    :disabled="isSubmitting"
                  />

                  <div
                    v-if="soanXongImageUrl"
                    class="image-preview-card"
                  >
                    <div class="image-wrapper" @click="showLightbox">
                      <img
                        :src="soanXongImageUrl"
                        alt="Ảnh đã soạn"
                        class="preview-img"
                      >
                      <div class="img-overlay">
                        <i class="fa fa-search-plus"></i>
                      </div>
                    </div>

                    <button
                      type="button"
                      class="btn btn-sm btn-danger btn-remove-img"
                      @click="soanXongImageUrl = null"
                      :disabled="isSubmitting"
                    >
                      Xóa ảnh
                    </button>
                  </div>
                </div>
              </div>

              <!-- FORM BÁO THIẾU HÀNG -->
              <div class="border rounded p-2 bg-light mb-3">
                <div class="d-flex align-items-center mb-2">
                  <i class="fa fa-exclamation-triangle text-warning mr-2"></i>
                  <strong>Báo Thiếu Hàng</strong>
                </div>

                <div class="form-group mb-2">
                  <label class="mb-1 font-weight-bold small">
                    Ghi chú gửi Sales (bắt buộc nếu thiếu)
                  </label>
                  <textarea
                    v-model.trim="baoThieuNote"
                    class="form-control form-control-sm"
                    rows="3"
                    placeholder="VD: Thiếu ống 90, khách ok lấy tạm 60..."
                    :disabled="isSubmitting"
                  ></textarea>
                </div>

                <button
                  type="button"
                  class="btn btn-warning btn-block mb-2"
                  @click="runSubmitBaoCaoThieuHang"
                  :disabled="isSubmitting || !baoThieuNote"
                >
                  <i class="fa fa-exclamation-triangle mr-1"></i>
                  Báo Thiếu Hàng
                </button>

                <div class="small text-muted">
                  Khi báo thiếu: Sales sẽ nhận thông tin ngay.
                </div>
              </div>

              <!-- NÚT XÁC NHẬN SOẠN XONG -->
              <button
                type="button"
                class="btn btn-success btn-lg btn-block"
                @click="runSubmitBaoCaoSoanXong"
                :disabled="isSubmitting || !soanXongImageUrl"
              >
                <span
                  v-if="isSubmitting"
                  class="spinner-border spinner-border-sm mr-2"
                ></span>
                XÁC NHẬN ĐÃ SOẠN ĐỦ HÀNG
              </button>
            </div>

            <div
              v-else-if="task.trangThai === 'DA_DEN' && task.loaiDiemDung === 'KHO_LAY'"
              class="section-block action-block"
            >
              <div class="section-header">
                <span class="section-index bg-danger text-white">4</span>
                <span class="section-title text-danger">
                  Xác minh bàn giao cho Tài xế
                </span>
              </div>

              <div class="alert alert-info font-weight-bold mb-2">
                <i class="fa fa-truck-loading mr-1"></i>
                Tài xế đã báo "ĐÃ ĐẾN". Vui lòng bàn giao hàng và chụp ảnh xác minh (Hàng + Tài xế/xe).
              </div>

              <!-- lỗi submit -->
              <div v-if="submitError" class="alert alert-danger py-2">
                {{ submitError }}
              </div>

              <!-- ẢNH XÁC MINH BÀN GIAO -->
              <div class="form-group mb-3">
                <label class="font-weight-bold d-block">
                  Ảnh xác minh bàn giao
                  <span class="text-danger">*</span>
                </label>

                <div class="d-flex flex-wrap align-items-start">
                  <CameraCapture
                    v-model="xacMinhImageUrl"
                    folder-name="kho_ban_giao"
                    file-name-prefix="ban-giao-tai-xe"
                    modal-title="Chụp ảnh bàn giao"
                    button-text="Chụp ảnh (Hàng + Tài xế)"
                    button-class="btn btn-outline-secondary btn-block btn-capture"
                    :disabled="isSubmitting"
                  />

                  <div
                    v-if="xacMinhImageUrl"
                    class="image-preview-card"
                  >
                    <div class="image-wrapper" @click="showXacMinhLightbox">
                      <img
                        :src="xacMinhImageUrl"
                        alt="Ảnh bàn giao"
                        class="preview-img"
                      />
                      <div class="img-overlay">
                        <i class="fa fa-search-plus"></i>
                      </div>
                    </div>

                    <button
                      type="button"
                      class="btn btn-sm btn-danger btn-remove-img"
                      @click="xacMinhImageUrl = null"
                      :disabled="isSubmitting"
                    >
                      Xóa ảnh
                    </button>
                  </div>
                </div>
              </div>

              <!-- NÚT XÁC NHẬN ĐÃ BÀN GIAO -->
              <button
                type="button"
                class="btn btn-danger btn-lg btn-block font-weight-bold"
                @click="runSubmitXacMinh"
                :disabled="isSubmitting || !xacMinhImageUrl"
              >
                <span
                  v-if="isSubmitting"
                  class="spinner-border spinner-border-sm mr-2"
                ></span>
                XÁC NHẬN ĐÃ BÀN GIAO HÀNG CHO TÀI XẾ
              </button>

              <div class="small text-muted mt-2 text-center">
                Sau khi xác nhận, điểm dừng này chuyển trạng thái
                <strong>KHO_DA_XAC_MINH</strong>.
              </div>
            </div>


            <!-- PHẦN 5: TRẠNG THÁI SAU KHI SOẠN -->
            <div
              v-else-if="task.trangThai === 'DA_SOAN_HANG'"
              class="section-block"
            >
              <div class="section-header">
                <span class="section-index bg-success text-white">ĐÃ SOẠN</span>
                <span class="section-title text-success">
                  Trạng thái sau soạn hàng
                </span>
              </div>

              <div
                v-if="task.loaiDiemDung === 'KHO_LAY'"
                class="alert alert-success font-weight-bold mb-2"
              >
                <i class="fa fa-check mr-1"></i>
                Đã soạn xong, chờ tài xế đến...
              </div>

              <div
                v-if="task.loaiDiemDung === 'KHACH_TU_LAY'"
                class="border rounded p-2 bg-light"
              >
                <div class="mb-2 font-weight-bold">
                  Khách sẽ tự đến kho để nhận hàng.
                </div>

                <div class="form-group mb-2">
                  <label class="mb-1">Tên người lấy hàng</label>
                  <input
                    v-model.trim="pickupForm.tenNguoiLayHang"
                    class="form-control form-control-sm"
                    placeholder="VD: Anh Tâm"
                    :disabled="isSubmitting"
                  />
                </div>

                <div class="form-group mb-2">
                  <label class="mb-1">Biển số xe khách</label>
                  <input
                    v-model.trim="pickupForm.bienSoXeKhach"
                    class="form-control form-control-sm"
                    placeholder="VD: 61A-12345"
                    :disabled="isSubmitting"
                  />
                </div>

                <div class="form-group mb-2">
                  <label class="mb-1">Ảnh xác minh giao hàng</label>
                  <div class="d-flex flex-wrap align-items-start">
                    <CameraCapture
                      v-model="pickupForm.imageUrl"
                      folder-name="kho_giao_tan_kho"
                      file-name-prefix="giao-cho-khach"
                      modal-title="Chụp ảnh giao khách"
                      button-text="Chụp ảnh giao khách"
                      button-class="btn btn-outline-secondary btn-block btn-capture"
                      :disabled="isSubmitting"
                    />
                    <div
                      v-if="pickupForm.imageUrl"
                      class="image-preview-card"
                    >
                      <div class="image-wrapper" @click="showPickupLightbox">
                        <img
                          :src="pickupForm.imageUrl"
                          class="preview-img"
                        />
                        <div class="img-overlay">
                          <i class="fa fa-search-plus"></i>
                        </div>
                      </div>

                      <button
                        type="button"
                        class="btn btn-sm btn-danger btn-remove-img"
                        @click="pickupForm.imageUrl = ''"
                        :disabled="isSubmitting"
                      >
                        Xóa ảnh
                      </button>
                    </div>
                  </div>
                </div>

                <button
                  type="button"
                  class="btn btn-primary btn-block font-weight-bold"
                  @click="runSubmitHoanThanhPickup"
                  :disabled="isSubmitting || !pickupForm.tenNguoiLayHang || !pickupForm.bienSoXeKhach || !pickupForm.imageUrl"
                >
                  <span
                    v-if="isSubmitting"
                    class="spinner-border spinner-border-sm mr-2"
                  ></span>
                  XÁC NHẬN ĐÃ GIAO CHO KHÁCH
                </button>
              </div>
            </div>

            <div
              v-else-if="task.trangThai === 'HOAN_THANH' || task.trangThai === 'BAO_THIEU_HANG'"
              class="section-block"
            >
              <div class="alert alert-success font-weight-bold text-center mb-0">
                <i class="fa fa-check-circle mr-1"></i>
                ĐÃ XỬ LÝ
              </div>
            </div>
          </div>
        </div>

        <div v-if="task" class="modal-footer modal-footer-mobile">
          <button
            type="button"
            class="btn btn-outline-secondary btn-block"
            @click="$emit('close')"
            :disabled="isSubmitting"
          >
            Đóng
          </button>
        </div>

        <vue-easy-lightbox
          :visible="lightboxVisible"
          :imgs="lightboxImages"
          :index="lightboxIndex"
          @hide="hideLightbox"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useKhoNhiemVuStore } from '@/stores/khoNhiemVuStore'
import CameraCapture from '@/components/CameraCapture.vue'
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
  name: 'KhoDetailModal',
  components: {
    CameraCapture,
    VueEasyLightbox
  },
  props: {
    task: { type: Object, required: true }
  },
  data () {
    return {
      pickupForm: {
        tenNguoiLayHang: '',
        bienSoXeKhach: '',
        imageUrl: ''
      },
      xacMinhImageUrl: null,

      soanXongImageUrl: null,
      baoThieuNote: '',
      lightboxVisible: false,
      lightboxIndex: 0,
      lightboxImages: []
    }
  },
  computed: {
    ...mapState(useKhoNhiemVuStore, ['isSubmitting', 'submitError'])
  },
  methods: {
    ...mapActions(useKhoNhiemVuStore, [
      'submitBaoCaoSoanXong',
      'submitHoanThanhPickup',
      'submitBaoCaoThieuHang',
      'submitXacMinhGiaoHang'
    ]),

    openSalesImage (url) {
      if (!url) return
      this.lightboxImages = [url]
      this.lightboxIndex = 0
      this.lightboxVisible = true
    },

    showLightbox () {
      if (!this.soanXongImageUrl) return
      this.lightboxImages = [this.soanXongImageUrl]
      this.lightboxIndex = 0
      this.lightboxVisible = true
    },

    showPickupLightbox () {
      if (!this.pickupForm.imageUrl) return
      this.lightboxImages = [this.pickupForm.imageUrl]
      this.lightboxIndex = 0
      this.lightboxVisible = true
    },

    hideLightbox () {
      this.lightboxVisible = false
    },

    onImgErr (e) {
      e.target.classList.add('img-fallback')
    },

    async runSubmitBaoCaoSoanXong () {
      if (!this.soanXongImageUrl) {
        alert('Phải chụp ảnh xác minh hàng đã soạn.')
        return
      }
      if (!confirm('Bạn chắc chắn đã soạn đủ hàng và chụp ảnh?')) return
      try {
        await this.submitBaoCaoSoanXong(this.task.id, this.soanXongImageUrl)
        alert('Báo cáo thành công!')
        this.$emit('report-success')
      } catch (error) {
        alert(this.submitError || 'Có lỗi xảy ra khi báo cáo.')
      }
    },

    async runSubmitBaoCaoThieuHang () {
      if (!this.baoThieuNote || this.baoThieuNote.trim() === '') {
        alert('Phải nhập ghi chú thiếu hàng.')
        return
      }
      try {
        await this.submitBaoCaoThieuHang(this.task.id, this.baoThieuNote.trim())
        alert('Đã gửi báo thiếu thành công cho Sales!')
        this.$emit('report-success')
      } catch (error) {
        alert(this.submitError || 'Có lỗi xảy ra khi báo thiếu.')
      }
    },

    async runSubmitXacMinh () {
      if (!this.xacMinhImageUrl) {
        alert('Vui lòng chụp ảnh xác minh bàn giao (hàng + tài xế + xe).')
        return
      }

      if (!confirm('Xác nhận đã bàn giao hàng cho tài xế?')) {
        return
      }

      try {
        await this.submitXacMinhGiaoHang(this.task.id, this.xacMinhImageUrl)
        alert('Đã xác minh bàn giao cho tài xế!')
        this.$emit('report-success')
      } catch (error) {
        alert(this.submitError || 'Có lỗi xảy ra khi xác minh.')
      }
    },

    async runSubmitHoanThanhPickup () {
      if (
        !this.pickupForm.tenNguoiLayHang ||
        !this.pickupForm.bienSoXeKhach ||
        !this.pickupForm.imageUrl
      ) {
        alert('Vui lòng nhập Tên người lấy, Biển số xe, và Ảnh xác minh.')
        return
      }
      try {
        const payload = {
          diemDungId: this.task.id,
          ...this.pickupForm
        }
        await this.submitHoanThanhPickup(payload)
        alert('Đã hoàn thành giao cho khách!')
        this.$emit('report-success')
      } catch (error) {
        alert(this.submitError || 'Có lỗi xảy ra khi hoàn thành.')
      }
    }
  }
}
</script>

<style scoped>
.modal-body {
    max-height: calc(100vh - 170px);
    overflow-y: auto;
}
.modal-overlay {
  background: rgba(0,0,0,.6);
}

.modal-full-mobile {
  max-width: 900px;
}

@media (max-width: 576px){
  .modal-dialog.modal-lg.modal-full-mobile {
    margin: 0;
    max-width: 100%;
    height: 100%;
  }
  .modal-content {
    min-height: 100vh;
    border-radius: 0;
    display: flex;
    flex-direction: column;
  }
  .modal-body {
    max-height: calc(100vh - 170px);
    overflow-y: auto;
  }
  .modal-footer-mobile {
    padding: 1rem;
    border-top: 1px solid #dee2e6;
  }
} 

.kho-modal-wrapper {
  border-radius: .75rem;
  overflow: hidden;
}

.modal-header {
  border-bottom: none;
  padding: 1rem 1rem .75rem 1rem;
}
.modal-body {
  background: #f8f9fa;
  padding: 1rem;
}
.modal-footer {
  border-top: none;
  padding: .75rem 1rem 1rem 1rem;
}

.section-block {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: .5rem;
  padding: 1rem;
  margin-bottom: 1rem;
}
.section-header {
  display: flex;
  align-items: center;
  margin-bottom: .75rem;
  flex-wrap: wrap;
}
.section-index {
  display: inline-block;
  min-width: 1.8rem;
  height: 1.8rem;
  line-height: 1.8rem;
  border-radius: .4rem;
  font-size: .8rem;
  font-weight: 600;
  text-align: center;
  margin-right: .5rem;
}
.section-title {
  font-weight: 600;
  font-size: .95rem;
}

.info-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: .5rem 0;
  border-bottom: 1px dashed #e1e1e1;
  font-size: .9rem;
}
.info-row:last-child {
  border-bottom: 0;
}
.info-label {
  flex: 0 0 120px;
  max-width: 120px;
  color: #6c757d;
  font-size: .8rem;
  line-height: 1.3;
  font-weight: 500;
}
.info-value {
  flex: 1;
  min-width: 0;
  word-break: break-word;
  font-size: .9rem;
  line-height: 1.4;
}

@media (max-width: 576px){
  .info-row {
    flex-wrap: wrap;
  }
  .info-label {
    flex: 0 0 100%;
    max-width: 100%;
    font-size: .75rem;
    margin-bottom: .25rem;
  }
  .info-value {
    flex: 0 0 100%;
    max-width: 100%;
    font-size: .9rem;
    background: #f8f9fa;
    border: 1px solid #e5e7eb;
    border-radius: .4rem;
    padding: .5rem .6rem;
  }
}

.pre-block {
  white-space: pre-wrap;
  margin: 0;
  font-family: inherit;
  font-size: .9rem;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  padding: .5rem .6rem;
  border-radius: .4rem;
  max-width: 100%;
  overflow-x: auto;
}
.min-100 {
  min-height: 100px;
}

.sales-image-thumb {
  position: relative;
  display: inline-block;
  cursor: zoom-in;
}
.sales-image-thumb img {
  border-radius: .5rem;
  max-width: 180px;
  max-height: 140px;
}
.sales-image-thumb .thumb-overlay {
  position: absolute;
  right: .5rem;
  bottom: .5rem;
  background: rgba(0,0,0,.6);
  color: #fff;
  font-size: .8rem;
  line-height: 1;
  padding: .3rem .4rem;
  border-radius: .4rem;
}

.image-preview-card {
  margin-top: .75rem;
  margin-left: 0;
  max-width: 180px;
}
@media (min-width: 577px){
  .image-preview-card {
    margin-left: .75rem;
  }
}
.image-wrapper {
  position: relative;
  border-radius: .5rem;
  border: 1px solid #dee2e6;
  overflow: hidden;
  cursor: zoom-in;
  background: #000;
}
.preview-img {
  width: 100%;
  height: 140px;
  object-fit: cover;
}
.img-overlay {
  position: absolute;
  right: .4rem;
  bottom: .4rem;
  background: rgba(0,0,0,.6);
  color: #fff;
  font-size: .8rem;
  line-height: 1;
  padding: .3rem .4rem;
  border-radius: .4rem;
}
.btn-remove-img {
  margin-top: .5rem;
  width: 100%;
}
.btn-capture {
  min-width: 140px;
  margin-right: .75rem;
  margin-bottom: .75rem;
}

.alert {
  font-size: .9rem;
}

.btn-block {
  width: 100%;
}
.btn-lg {
  font-size: 1rem;
  padding-top: .8rem;
  padding-bottom: .8rem;
  font-weight: 600;
}
.font-weight-bold {
  font-weight: 600 !important;
}

.img-fallback {
  object-fit: contain !important;
}
</style>
